export default "__VITE_ASSET__BTSiwOFF__"